import { getDurableJobApi } from '../api';
import { downloadFromUrl } from '@/shared/utils/downloadBlob';

export async function executeDownloadDocumentFolderZip(jobId: string): Promise<void> {
    const full = await getDurableJobApi(jobId);
    const folderName = (full.params as { folderName?: string } | undefined)?.folderName;
    const file = full.result?.data as { link?: string; path?: string; name?: string } | undefined;
    const url = file?.link ?? file?.path;
    if (!url) {
        return;
    }
    // the zip carries its download name, so the browser saves it straight to disk instead of buffering it in the tab
    downloadFromUrl(url, folderName ?? file?.name);
}
